var _circle;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconLoading(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 200 200",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    fill: "none",
    strokeOpacity: 1,
    stroke: "#D0D0D0",
    strokeWidth: 0.5,
    cx: 100,
    cy: 100,
    r: 0
  }, /*#__PURE__*/React.createElement("animate", {
    attributeName: "r",
    calcMode: "spline",
    dur: 2,
    values: "1;80",
    keyTimes: "0;1",
    keySplines: "0 .2 .5 1",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-width",
    calcMode: "spline",
    dur: 2,
    values: "0;25",
    keyTimes: "0;1",
    keySplines: "0 .2 .5 1",
    repeatCount: "indefinite"
  }), /*#__PURE__*/React.createElement("animate", {
    attributeName: "stroke-opacity",
    calcMode: "spline",
    dur: 2,
    values: "1;0",
    keyTimes: "0;1",
    keySplines: "0 .2 .5 1",
    repeatCount: "indefinite"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconLoading);
export default __webpack_public_path__ + "static/media/icon_loading.fac397b0354fc81fc90b6aa6e8fe38fd.svg";
export { ForwardRef as ReactComponent };